module.exports = __webpack_public_path__ + "img/previewer_image.6e585098.jpg";